<template>
    <div class="v-radio-buttons">
        <div class="v-radio-button" v-for="button in buttons" :key="button.id">
            <div class="radio-button-icon" @click="setActive(button)">
                <transition name="fade-scale">
                    <div class="active-icon" v-if="button.isActive"></div>
                </transition>
            </div>
            <p @click="setActive(button)">{{ button.text }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VRadioButton',

    props: {
        buttons: {
            type: Array,
            required: true,
        }
    },

    methods: {
        setActive(button) {
            this.buttons.forEach(item => {
                item.isActive = false;
            })
            button.isActive = true;
        }
    }
}
</script>

<style lang="scss">
.v-radio-buttons {
    display: flex;
    flex-direction: column;
    gap: 5px;

    .v-radio-button {
        display: flex;
        align-items: center;
        gap: 10px;

        p {
            cursor: pointer;
            user-select: none;
        }

        .radio-button-icon {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: var(--color-bg-light);
            display: flex;
            align-items: center;
            justify-content: center;
            //box-shadow: 0 0 4px var(--color-bg-light);

            cursor: pointer;

            .active-icon {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: var(--color-blue);
                box-shadow: 0 0 5px 2px color-mix(in srgb, var(--color-blue) 50%, transparent);
            }
        }
    }
}

.fade-scale-enter-active,
.fade-scale-leave-active {
    transition: all 0.2s ease;
}

.fade-scale-enter-from,
.fade-scale-leave-to {
    opacity: 0;
    transform: scale(0.2);
}
</style>
